module.exports = __webpack_public_path__ + "static/media/Artboard11.a4de17a7.png";